import React, { useContext } from 'react';

import { VARIANT } from '../../../constants';
import { dark } from '../constants/dark';
import { ThemeContextProps } from '../types';

export const ThemeContext = React.createContext<ThemeContextProps>({
  theme: dark,
  variant: VARIANT.DARK,
});

export const useThemeContext = () => useContext(ThemeContext) as ThemeContextProps;
